/*
* Impulse Theme
*
* Use this file to add custom Javascript to Impulse.  Keeping your custom
* Javascript in this file will make it easier to update Impulse. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line







  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.

  /* EM */
  window.themeObj = {
    init: () => {
      const obj = window.themeObj;

      obj.templates.init();
    }
  };

  window.themeObj.templates = {
    init: () => {
      const obj = window.themeObj.templates;

      if (document.body.classList.contains('template-collection') || document.body.classList.contains('template-index')) {
        obj.collection.init();
      }
    },
    collection: {
      init: () => {
        const obj = window.themeObj.templates.collection;

        obj.footer();
      },
      footer: () => {
        const wrapper = document.querySelector('.collection__footer');

        if (wrapper) {
          const content = wrapper.querySelector('.collection__footer-content');

          if (content && content.clientHeight >= 150) {
            wrapper.classList.add('is-collapsed');

            const button = wrapper.querySelector('.btn');

            button.addEventListener('click', () => {
              wrapper.classList.remove('is-collapsed');
            });
          }
        }
      }
    }
  };

  document.addEventListener('DOMContentLoaded', () => {
    window.themeObj.init();
  });
  /* /EM */

  /* Custom Mobile Button */
  document.addEventListener('DOMContentLoaded', function() {
  const mobileBuyButton = document.querySelector('.mobile-buy-buttons');

  if (mobileBuyButton) {
    mobileBuyButton.addEventListener('click', function(event) {
      event.preventDefault();

      const addToCartButton = document.querySelector('.add-to-cart');

      if (addToCartButton) {
        const offset = window.innerHeight / 2 - 200;
        const buttonPosition = addToCartButton.getBoundingClientRect().top + window.pageYOffset;
        const scrollTarget = buttonPosition - offset;

        // Scroll to the target position
        window.scrollTo({
          top: scrollTarget,
          behavior: 'smooth'
        });

        // Function to click the button
        const clickButton = () => {
          addToCartButton.click();
        };

        // Use scrollend event if supported
        if ('onscrollend' in window) {
          window.addEventListener('scrollend', clickButton, { once: true });
        } else {
          // Fallback for browsers that don't support scrollend
          let lastKnownScrollPosition = window.pageYOffset;
          let ticking = false;

          const checkScrollEnd = () => {
            if (Math.abs(window.pageYOffset - scrollTarget) < 2) {
              clickButton();
            } else if (window.pageYOffset !== lastKnownScrollPosition) {
              lastKnownScrollPosition = window.pageYOffset;
              window.requestAnimationFrame(checkScrollEnd);
            } else {
              setTimeout(checkScrollEnd, 50);
            }
          };

          window.requestAnimationFrame(checkScrollEnd);
        }
      }
    });
  }
  });

  document.addEventListener("DOMContentLoaded", function() {
    const collectionFilter = document.querySelector('.collection-filter');

    if (collectionFilter) {
        // Set the desired top position initially
        collectionFilter.style.top = '75px';

        // Reapply the top style every second to prevent changes
        setInterval(() => {
            collectionFilter.style.top = '75px';
        }, 1000);
    }
  });

  document.addEventListener("DOMContentLoaded", function () {
  const readMoreButton = document.querySelector(".collection-description-toggle");
  const descriptionWrapper = document.querySelector(".collection__description-wrapper");

  if (readMoreButton && descriptionWrapper) {
    // Initially, set the content to collapsed and show the "Read More" button
    descriptionWrapper.classList.add("is-collapsed");
    readMoreButton.textContent = "Read More";

    // Button click event listener
    readMoreButton.addEventListener("click", function () {
      const description = descriptionWrapper.querySelector(".collection__description");

      // Check if description is collapsed or expanded, and toggle state accordingly
      if (descriptionWrapper.classList.contains("is-collapsed")) {
        // Expanding the description
        descriptionWrapper.classList.remove("is-collapsed");
        descriptionWrapper.classList.add("is-expanded");
        readMoreButton.textContent = "Read Less"; // Change button text
      } else {
        // Collapsing the description
        descriptionWrapper.classList.remove("is-expanded");
        descriptionWrapper.classList.add("is-collapsed");
        readMoreButton.textContent = "Read More"; // Change button text
      }
    });
  }
  });

  document.addEventListener("DOMContentLoaded", function () {
  const footerButton = document.querySelector(".read-more-button");
  const footerContent = document.querySelector(".collection__footer-content");

  if (footerButton && footerContent) {
    footerButton.addEventListener("click", function () {
      if (footerContent.classList.contains("collapsed")) {
        // Expanding the footer content
        footerContent.classList.remove("collapsed");
        footerButton.textContent = "Read Less";
      } else {
        // Collapsing the footer content
        footerContent.classList.add("collapsed");
        footerButton.textContent = "Read More";
      }
    });
  }
  });

})();


(function() {
  const showMoreCollectionDescription = () => {
    const descriptionWrapper = document.querySelector('.collection__description-wrapper');

    if (descriptionWrapper) {
      const description = descriptionWrapper.querySelector('.collection__description');
      const toggleButton = descriptionWrapper.querySelector('.collection-description-toggle');

      if (description && toggleButton) {
        // Collapse if content is longer than 155px
        if (description.clientHeight >= 155) {
          descriptionWrapper.classList.add('is-collapsed');
        } else {
          toggleButton.style.display = 'none'; // Hide button if content is already short
        }

        // Click event to expand
        toggleButton.addEventListener('click', () => {
          descriptionWrapper.classList.remove('is-collapsed');
        });
      }
    }
  };

  document.addEventListener('DOMContentLoaded', showMoreCollectionDescription);
})();
